var _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _path4, _path5, _circle6, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 145,
    viewBox: "0 0 144 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.12,
    cy: 70,
    r: 70,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.859 120.882c.573-1.097 2.143-1.098 2.716-.001l3.371 6.456a.762.762 0 0 0 .324.324l6.458 3.373c1.097.573 1.096 2.142-.001 2.715l-6.457 3.369a.772.772 0 0 0-.325.325l-3.37 6.458c-.573 1.097-2.144 1.097-2.716-.001l-3.366-6.457a.764.764 0 0 0-.324-.325l-6.461-3.369c-1.098-.572-1.098-2.143-.001-2.715l6.462-3.373a.759.759 0 0 0 .324-.325l3.366-6.454zM33.748 1.513a.89.89 0 0 1 1.58 0l1.96 3.755c.043.08.108.146.189.188l3.756 1.962a.89.89 0 0 1 0 1.58l-3.756 1.96a.444.444 0 0 0-.189.188l-1.96 3.756a.89.89 0 0 1-1.58 0l-1.957-3.756a.446.446 0 0 0-.19-.189l-3.758-1.96a.89.89 0 0 1 0-1.579l3.759-1.962a.446.446 0 0 0 .189-.188l1.957-3.755z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.955 37.732a.658.658 0 0 1 1.167 0l1.449 2.774c.031.06.08.108.14.14l2.775 1.45a.658.658 0 0 1 0 1.166l-2.775 1.448a.327.327 0 0 0-.14.14l-1.449 2.776a.658.658 0 0 1-1.167 0l-1.446-2.776a.333.333 0 0 0-.14-.14l-2.777-1.448a.658.658 0 0 1 0-1.167l2.777-1.45a.333.333 0 0 0 .14-.14l1.446-2.773zM7.621 96.836a.959.959 0 0 1 1.7 0l2.11 4.04a.476.476 0 0 0 .203.203l4.043 2.112a.958.958 0 0 1 0 1.699l-4.043 2.109a.484.484 0 0 0-.203.204l-2.11 4.042a.959.959 0 0 1-1.7 0l-2.107-4.042a.484.484 0 0 0-.203-.204l-4.045-2.109a.959.959 0 0 1 0-1.7l4.045-2.111a.476.476 0 0 0 .203-.203l2.107-4.04z",
    fill: "#EFEFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.267 90.248V52.964a1.6 1.6 0 0 1 1.6-1.6h49.671c1.041 0 1.972.652 2.328 1.63l5.769 15.847a.8.8 0 0 0 .637.518l6.939 1.007a4.956 4.956 0 0 1 4.243 4.905v15.778a.8.8 0 0 1-.8.8H43.867a1.601 1.601 0 0 1-1.6-1.6z",
    fill: "#fff",
    stroke: "#73767D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.995,
    cy: 91.85,
    r: 6.191,
    fill: "#fff",
    stroke: "#73767D",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.995,
    cy: 91.85,
    r: 3.898,
    fill: "#73767D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.346,
    cy: 91.85,
    r: 6.191,
    fill: "#fff",
    stroke: "#73767D",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.346,
    cy: 91.85,
    r: 3.898,
    fill: "#73767D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.427 69.343H88.08a1.239 1.239 0 0 1-1.24-1.24v-9.838",
    stroke: "#73767D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.311 69.343h11.115l-3.824-10.435a1 1 0 0 0-.939-.656h-7.59v9.852c0 .684.554 1.239 1.238 1.239z",
    fill: "#73767D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.054,
    cy: 58.252,
    r: 17.457,
    fill: "#31B59F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.054 45.742a1 1 0 0 1 1 1v8.995a2.707 2.707 0 0 1-1.986 5.036l-3.877 3.76a1 1 0 0 1-1.392-1.437l3.806-3.69a2.707 2.707 0 0 1 1.449-3.668v-8.996a1 1 0 0 1 1-1z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m32.79 42.706-3.773-2.752M29.637 51.52l-2.229.236M40.856 38.33l-.164-2.257",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHours);
export default __webpack_public_path__ + "static/media/work-hours.e981cd81f6fcd5c60edfc508dd632c75.svg";
export { ForwardRef as ReactComponent };